import { IoGitNetworkOutline, IoLocationOutline } from 'react-icons/io5';

import { GoOrganization } from 'react-icons/go';
import { HiOutlineUserGroup } from 'react-icons/hi2';
import { IconType } from 'react-icons/lib';
import { LiaUserGraduateSolid } from 'react-icons/lia';

export const contentTypeIconMap: { [key: string]: IconType } = {
  location: IoLocationOutline,
  department: IoGitNetworkOutline,
  team: HiOutlineUserGroup,
  orgLevel: GoOrganization,
  grade: LiaUserGraduateSolid,
  group: HiOutlineUserGroup,
};
